import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultIntegratedRewardsPage from './Pages/DefaultIntegratedRewardsPage';
import DefaultIntegratedRewardsAccessPage from './Pages/DefaultIntegratedRewardsAccessPage';
import WizardPage from './Pages/WizardPage';

const IntegratedRewardsRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/:level/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:level/:dashboardId/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/settings`}>
                <DefaultIntegratedRewardsAccessPage />
            </Route>
            <Route default>
                <DefaultIntegratedRewardsPage />
            </Route>
        </Switch>
    );
};

export default IntegratedRewardsRouter;
